// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"popups_Wrapper__teXLZ","Popup":"popups_Popup__KoGn2","zoomIn":"popups_zoomIn__9bVo9","Close":"popups_Close__A4H02","Content":"popups_Content__2_ry4"};